module.exports = __webpack_public_path__ + "static/shopify_5-231ba6d0f334a5adfd1377bb390396ed.png";